exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pocket-a{fill:#ff4158;}\n.pocket-b{fill:none;}", ""]);
